import { post } from "..";
import useApiActions from "../../recoil/api";

const useApplyActions = () => {
  const { getWithToken, postFormWithToken, postWithToken } = useApiActions();

  return { uploadUserRecordFile, getExamResult, applySubmit };

  async function uploadUserRecordFile(params) {
    const res = await postFormWithToken("file/exam", params);
    return res;
  }

  async function getExamResult() {
    const res = await getWithToken("apply/done");
    return res;
  }

  async function applySubmit(params) {  
    const res = await postWithToken("apply/submit", params);
    return res;
  }
};

export default useApplyActions;
